import React, { useState } from "react";
import "./UserList.css";
import { useSelector } from 'react-redux';
import {translate} from "./Language/Translate"
import Auth from "../helpers/auth";
import UserNew from "../newForms2/users/UserNew";
import UserListItem from "./UserListItem";
import { sortArrayByObjectField } from "../helpers/sort";

function CompanyUserList() {
  const [formUserNew, setFormUserNew] = useState(false);
  const currentUser = useSelector(st => st.currentUser);
  const currentCompany = useSelector(st => st.currentCompany);
  const userStatus = currentUser?.userStatus;
  const userlist = currentCompany?.users || [];
  const admins = userlist.filter(u => u.userStatus.includes('admin') || u.userStatus.includes('mainAdmin'));
  const subAdmins = userlist.filter(u => u.userStatus.includes('subAdmin'));
  const users = userlist.filter(u => u.userStatus.includes("user"));

  // console.log({userlist, admins, subAdmins, users})

  
  const List = ({users, headline}) => {

    if(!users.length)return null;
    const newArr = sortArrayByObjectField([...users.map(u => {return{...u, sort:`${u.lastName} ${u.firstName}`}})], "sort");
    return(
      <div className="mt-4">
        <h5>{headline}</h5>
        <ul>
          {newArr.map(u => <UserListItem key = {u.username} user={u}/>)}
        </ul>
        
      </div>

    )
  };
  return (
    <div>
      {/* <h5>{translate("Users")}</h5> */}
      {Auth.isAdmin(userStatus, currentCompany.id) && 
          <button className="btn btn-info" onClick={() => setFormUserNew(true)}>
              {translate("Add User")}
          </button>}
      {formUserNew && <UserNew setFormUserNew={setFormUserNew}/>}
      <List users={admins} headline="Administratoren"/>
      <List users={subAdmins} headline = "Sub-Administratoren"/>
      <List users={users} headline = "Benutzer (nur Leserechte)"/>
    </div>
  );
}

export default CompanyUserList;